<template>
  <div>
    <div v-if="suppliers.length == 0">
      <v-row>
        <p class="ma-2 text-center">
          You have not registered any suppliers. Please import your suppliers or
          add them manually.
        </p>
      </v-row>
      <v-row>
        <div class="d-flex">
          <PPrimaryButton
            @click="openDialog = true"
            appkit-icon="icon-plus-fill"
            class="ma-2"
          >
            Add suppliers
          </PPrimaryButton>
          <UploadSuppliersDialog
            :open-dialog="openDialog"
            @close-dialog="openDialog = false"
            @uploaded-suppliers="
              openDialog = false;
              emit('supplierListChanged');
            "
          />
        </div>
      </v-row>
    </div>
    <div v-else>
      <div class="d-flex justify-space-between">
        <div class="d-flex justify-end mb-10">
          <v-spacer />
          <ExportSuppliers class="mx-2" />
          <PPrimaryButton
            @click="openDialog = true"
            appkit-icon="icon-plus-fill"
          >
            Add suppliers
          </PPrimaryButton>
          <UploadSuppliersDialog
            :open-dialog="openDialog"
            @close-dialog="openDialog = false"
            @uploaded-suppliers="
              openDialog = false;
              emit('supplierListChanged');
            "
          />
        </div>
      </div>
      <SuppliersTable
        :is-loading="isLoading"
        :suppliers="suppliers"
        @change="emit('supplierListChanged')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import SuppliersTable from "@/views/supplier-registry/SuppliersTable.vue";
import type { Supplier } from "@/models/supplier";
import ExportSuppliers from "@/views/supplier-registry/ExportSuppliers.vue";
import { ref } from "vue";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import UploadSuppliersDialog from "./UploadSuppliersDialog.vue";

defineProps<{
  suppliers: Array<Supplier>;
  canUploadBusinessPartner: boolean;
}>();

const emit = defineEmits<{
  (e: "supplierListChanged"): void;
}>();

const isLoading = ref(false);

const openDialog = ref(false);
</script>
